import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { fleaMarketItemListInfiniteQueryOptions } from "~/features/fleamarket/api";
import { FleaMarketTemplate } from "~/features/fleamarket/FleaMarketTemplate";

const searchSchema = z.object({
  tab: z.enum(["items", "favorites", "transactions"]).default("items"),
});

export const Route = createFileRoute("/_authenticated/fleamarket/")({
  validateSearch: searchSchema,
  // API 未配備時にも画面遷移できるよう loader の例外は無視する（Template の isError で処理）
  loader: ({ context: { queryClient } }) =>
    queryClient
      .ensureInfiniteQueryData(fleaMarketItemListInfiniteQueryOptions())
      .catch(() => undefined),
  component: FleaMarketTemplate,
});
